import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "@/data/content";

export default function Services() {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 md:py-36 px-6 sm:px-10 lg:px-16"
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="text-xs font-sans tracking-[0.22em] uppercase text-zinc-500 overline-line">
              Ways We Work Together
            </div>
            <h2 className="mt-6 font-serif text-4xl sm:text-5xl md:text-6xl font-light leading-[1.05] text-white">
              Coaching containers, <br />
              <span className="italic text-rainbow">designed around your becoming.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-zinc-400 text-lg leading-relaxed">
              Whether you want a private one-on-one container or to walk this
              work alongside others, there's a space here meeting you where you
              are.
            </p>
          </div>
        </div>

        {/* Cardless bento grid */}
        <div className="grid md:grid-cols-2 gap-px bg-brand-border rounded-3xl overflow-hidden border border-brand-border">
          {SERVICES.map((svc) => (
            <article
              key={svc.id}
              data-testid={`service-${svc.id}`}
              className={`relative p-10 md:p-12 bg-brand-surface hover-lift ${
                svc.featured ? "md:row-span-1" : ""
              }`}
            >
              {svc.featured && (
                <span className="absolute top-6 right-6 chip" data-testid={`service-${svc.id}-featured-badge`}>
                  <span
                    className="h-1.5 w-1.5 rounded-full"
                    style={{ background: svc.accent }}
                  />
                  Most loved
                </span>
              )}

              <div className="flex items-baseline justify-between gap-4">
                <div>
                  <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">
                    {svc.duration}
                  </div>
                  <h3 className="mt-3 font-serif text-3xl sm:text-4xl text-white leading-tight">
                    {svc.name}
                  </h3>
                </div>
                <div className="text-right">
                  <div
                    className="font-serif text-3xl whitespace-nowrap"
                    style={{ color: svc.accent }}
                  >
                    {svc.price}
                  </div>
                </div>
              </div>

              <p className="mt-5 text-zinc-400 leading-relaxed max-w-md">
                {svc.blurb}
              </p>

              <ul className="mt-6 space-y-3">
                {svc.bullets.map((b, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 text-sm text-zinc-300"
                  >
                    <span
                      className="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full border"
                      style={{ borderColor: svc.accent }}
                    >
                      <Check size={12} strokeWidth={2} style={{ color: svc.accent }} />
                    </span>
                    {b}
                  </li>
                ))}
              </ul>

              <button
                data-testid={`service-${svc.id}-cta`}
                onClick={() => go("contact")}
                className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-white group/btn"
              >
                <span
                  className="border-b border-dotted pb-0.5"
                  style={{ borderColor: svc.accent }}
                >
                  Begin this work
                </span>
                <ArrowUpRight
                  size={16}
                  strokeWidth={1.75}
                  className="group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition"
                  style={{ color: svc.accent }}
                />
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
